import React, { useState, useEffect } from "react";
import OfferLetter from "../components/OfferLetter";
import { useParams } from "react-router-dom";
import axiosInstance from "../axiosInstance";
import { server_API } from "../config";
import axios from "axios";
import Select from "react-select";
import cross from "../images/Vector.svg";
import success from "../images/success.png";
import { createNotification } from "../components/NotificationFunctions";
import { TailSpin } from "react-loader-spinner";
import { parseCustomDate } from "../utils/dateUtils";

const OfferLetterAcceptance = () => {
  const params = useParams();
  const [applicant, setApplicant] = useState({});
  const [companyDetails, setCompanyDetails] = useState({});
  const [allOfferLetter, setOfferLetterDetails] = useState({});
  const [jobDetails, setJobDetails] = useState();
  const [jobId, setJobId] = useState("");
  const [logo, setLogo] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [rejectReason, setRejectReason] = useState("");
  const [furtherExplaination, setFurtherExplaination] = useState("");
  const [openAcceptModal, setAcceptModal] = useState(false);
  const [userIPAddress, setUserIPAddress] = useState("");
  const [loader, setloader] = useState(false);
  const aid = params.aid;
  const cid = params.cid;

  const rejectionOptions = [
    { value: "Found a better job offer", label: "Found a better job offer" },
    {
      value: "⁠Retained by the current employer",
      label: "⁠Retained by the current employer",
    },
    { value: "Do not want to disclose", label: "Do not want to disclose" },
  ];

  useEffect(() => {
    axiosInstance
      .get(`/v2/applicant/get/${aid}/${cid}`)
      .then((response) => {
        // console.log(response);
        setJobId(response.data.jobid);
        setApplicant(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
    axios
      .get("https://geolocation-db.com/json/")
      .then((res) => {
        console.log(res);
        setUserIPAddress(
          `${res.data.IPv4} lat:${res.data.latitude} long:${res.data.longitude}`
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const updateStatus = (stat) => {
    const payload = {
      uuid: applicant.uuid,
      status: stat,
      companyid: cid,
    };
    axios
      .patch(`${server_API}/v2/applicant/update`, payload)
      .then((res) => {
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleReject = () => {
    axios
      .patch(`${server_API}/v2/offer/update`, {
        uuid: allOfferLetter[0].uuid,
        status: "Rejected",
        rejectionreason: rejectReason,
        explaination: furtherExplaination,
        companyid: cid,
        acceptancelocation: userIPAddress,
        acceptancedate: new Date(),
      })
      .then((res) => {
        console.log(res);
        updateStatus("Offer Rejected");
        createNotification(
          cid,
          jobDetails.assignrecruiter,
          "",
          "Offer letter rejected",
          `${applicant.name} has rejected the offer letter for the job opening of ${jobDetails.profilename}`,
          ""
        );
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSelect = () => {
    setloader(true);
    axios
      .patch(`${server_API}/v2/offer/update`, {
        uuid: allOfferLetter[0].uuid,
        status: "Accepted",
        companyid: cid,
        acceptancelocation: userIPAddress,
        acceptancedate: new Date(),
      })
      .then((res) => {
        console.log(res);
        updateStatus("Accepted");
        createNotification(
          cid,
          jobDetails.assignrecruiter,
          "",
          "Offer letter accepted",
          `${applicant.name} has accepted the offer letter for the job opening of ${jobDetails.profilename}`,
          ""
        );
        setloader(false);
        setAcceptModal(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (jobId.length > 0) {
      axiosInstance
        .get(`/v2/job/get/${jobId}/${cid}`)
        .then((response) => {
          console.log(response);
          setJobDetails(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [jobId]);

  useEffect(() => {
    axiosInstance
      .get(`/v2/company/get/${cid}`)
      .then((res) => {
        setCompanyDetails(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(`${server_API}/v2/offer/get/applicant/${aid}/${cid}`)
      .then((res) => {
        setOfferLetterDetails(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (companyDetails) {
      axios
        .get(`${server_API}/v2/company/geturl/${companyDetails.uuid}`)
        .then((response) => {
          console.log(response);
          setLogo(response.data.url);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [companyDetails]);

  if (jobDetails)
    return (
      <div>
        {openModal && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/3 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <img
                src={cross}
                onClick={() => {
                  setOpenModal(false);
                }}
                className="h-3 float-right"
              ></img>
              <p className="mt-5 mb-3">Rejection Reason</p>
              <Select
                options={rejectionOptions}
                onChange={(option) => {
                  setRejectReason(option.value);
                }}
              ></Select>
              <p className="mt-3">Reason</p>
              <textarea
                className="w-full border-2 outline-none p-2 mt-1 rounded-lg"
                rows="3"
                placeholder="Describe the reason here"
                value={furtherExplaination}
                onChange={(e) => {
                  setFurtherExplaination(e.target.value);
                }}
              ></textarea>
              <div className="mt-4 text-center">
                <button
                  onClick={handleReject}
                  className="bg-[#148EFF] text-white rounded-lg px-3 py-2"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}
        {openAcceptModal && (
          <div className="fixed inset-0 bg-white bg-opacity-20 backdrop-blur-lg z-40 flex items-center justify-center">
            <div className="fixed -translate-x-1/2 w-1/2 z-50 bg-white px-8 p-5 rounded-lg shadow-xl -translate-y-1/2 left-1/2 top-1/2">
              <img
                src={cross}
                onClick={() => {
                  window.location.reload();
                }}
                className="h-3 float-right"
              ></img>
              <img src={success} className="mt-5 h-40 mx-auto mb-3"></img>

              <p className="text-center mt-5 text-2xl">
                Thank you for your response, the hiring team will reach out for
                next steps.
              </p>
            </div>
          </div>
        )}
        <div className="bg-[#f1f4f8] min-h-screen px-40 py-20">
          <div className=" rounded-2xl py-10 bg-white flex items-start justify-between">
            <div className="w-1/2 sticky top-5 p-10">
              <img src={logo} className="h-6 my-4"></img>
              <p className="text-2xl">Offer Letter</p>
              <p className="text-sm text-slate-500">This might take a while, please don't refresh the page</p>
            </div>
            {(() => {
              const rawDate = allOfferLetter[0]?.expirydate;
              const expiryDate = parseCustomDate(rawDate);

              if (expiryDate && !isNaN(expiryDate.getTime())) {
                expiryDate.setHours(23, 59, 59, 999);
              }
              const today = new Date();

              const isValid =
                (expiryDate &&
                  today <= expiryDate && allOfferLetter[0].status === "Acceptance Awaited");

              return isValid ? (
                <div className="w-1/2">
                  <OfferLetter
                    applicant={applicant}
                    companyDetails={companyDetails}
                    offerLetterDetails={allOfferLetter}
                    jobDetails={jobDetails}
                    offerstatus={allOfferLetter[0].status}
                    showButton={false}
                  />
                  <div className="flex items-center pr-4 justify-end space-x-5">
                    <button
                      onClick={() => {
                        setOpenModal(true);
                      }}
                      className="text-[#A0A0A0]"
                    >
                      Reject
                    </button>
                    <button
                      onClick={() => {
                        handleSelect();
                      }}
                      className="bg-[#2656C9] text-white rounded-full px-4 py-2"
                    >
                      {loader ? (
                        <TailSpin color="white" height="30" width="30" />
                      ) : (
                        "Agree"
                      )}
                    </button>
                  </div>
                </div>
              ) : (
                <p className="w-1/2">
                  The offer letter has expired or is invalid.
                </p>
              );
            })()}

          </div>
          <div className="flex items-center text-xs mt-2 pr-4 justify-end space-x-5">
            <p>Help</p>
            <p>Privacy</p>
            <p>Terms</p>
          </div>
        </div>
      </div>
    );
};

export default OfferLetterAcceptance;
